import { FC } from "react";
import "./style.scss";
import { ReactComponent as BalanceIcon } from "../../../../assets/Balance.svg";
import { ReactComponent as PerformanceIcon } from "../../../../assets/Performance.svg";
import { useTranslation } from "react-i18next";
import { IsVelarApp, SvgIcon } from "static/types";

type PropsType = {
  type: "Balance" | "Assets";
  active: boolean;
  onClick: () => void;
};

const BalanceWidgetTab: FC<PropsType> = ({ type, active, onClick }) => {
  const { t } = useTranslation("app");

  const Icon: SvgIcon =
    type === "Balance" ? BalanceIcon : PerformanceIcon;

  return (
    <button
      onClick={onClick}
      className={`balance-widget-tab${active ? "-active" : ""}`}
    >
      <Icon
        className={`balance-widget-tab-icon${
          IsVelarApp && active ? " balance-widget-tab-velar-icon" : ""
        }`}
        aria-hidden
      />
      <p>{t(type.toLowerCase())}</p>
    </button>
  );
};

export default BalanceWidgetTab;
